import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/thermal-expansion-calculator',
  component: () => import('../../routes/ThermalExpansionCalculator.svelte'),
  card: {
    id: 'thermal-expansion-calculator',
    title: 'Thermal Expansion Calculator',
    description:
      'Calculate length change (ΔL = α·L₀·ΔT) and final length for any material. Solves for final length, original length, coefficient α, or temperature change. Includes 24 material presets (steel, aluminum, copper, brass, PVC, glass, Invar, PTFE, wood, concrete) and 5 real-world scenarios (bridge decks, engine pistons, plumbing pipes, highway slabs, cryogenic rods).',
    icon: 'straighten',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/thermal-expansion-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Thermal Expansion Calculator – ΔL = α·L₀·ΔT, with Material Presets',
    description:
      'Free thermal expansion calculator using ΔL = α·L₀·ΔT. Solves for final length, original length, coefficient α, or temperature change. Includes 24 material presets (steel, aluminum, copper, brass, PVC, glass, Invar, PTFE, wood, concrete) and area/volume coefficient derivations.',
  },
};

export default meta;
